const styles = {
  formContainer: {
    px: 3,
  },
  fullWidth: {
    width: "100%",
  },
};

export default styles;
